function App() {
  return <div className="JppCompta-banner"></div>;
}

export default App;
